export const routes = {
  home: '/',
  callendar: '/callendar',
  statistics: '/statistics',
  settings: '/settings',
};
